export default "__VITE_ASSET__CK$lcMXH__"